import React, { useEffect, useRef, useState } from 'react';
import { _T } from 'appI18n';
import AsyncLoadError from './AsyncLoadError';
import AsyncSpinner from './AsyncSpinner';
let uidCounter = 1;
export default function HotelLocation(props) {
    const [initStatus, setInitStatus] = useState('none');
    const [uniqueId] = useState(() => "google-maps-" + uidCounter++);
    const ref = useRef(null);
    const [map, setMap] = useState();
    const [marker, setMarker] = useState();
    useEffect(() => {
        if (ref.current && !map) {
            const position = { lat: props.description.latitude, lng: props.description.longitude };
            setMap(new google.maps.Map(ref.current, {
                zoom: 15,
                center: position
            }));
        }
    }, [ref, map, props.description.latitude, props.description.longitude]);
    useEffect(() => {
        if (ref.current && map) {
            const position = { lat: props.description.latitude, lng: props.description.longitude };
            setMarker(new google.maps.Marker({ position, map, title: props.description.hotelName }));
        }
    }, [ref, map]);
    return React.createElement("div", null, (() => {
        var _a;
        if (initStatus == 'loading')
            return React.createElement(AsyncSpinner, null);
        if (initStatus == 'error')
            return React.createElement(AsyncLoadError, { errorText: _T.TOUR_ERROR_LOADING_MAP });
        return React.createElement("div", { id: uniqueId, style: { height: `${(_a = props.height) !== null && _a !== void 0 ? _a : 240}px` }, ref: ref });
    })());
}
